import Translator from '../../../Shared/translator';
import v1_v2 from './v1_v2';

const translator: Translator = {
  ['v1_v2']: v1_v2
};

export default translator;
